import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {styled} from "@mui/material/styles";
import {BadgeContext} from "../BadgeContext";

Label.propTypes = {
    label: PropTypes.string,
};

const StyledLabel = styled('span', {
    shouldForwardProp: (prop) => !['isBold', 'color', 'labelSize'].includes(prop)
})(({ theme, color, isBold, labelSize }) => ({
    lineHeight: 'inherit',
    color: theme.palette[color]?.main ?? color,
    fontSize: `${labelSize}px`,
    fontWeight: isBold ? 600 : 400,
    whiteSpace: 'nowrap'
}));

function Label({label, ...props}) {
    const {color, labelColor, isBold, labelSize} = useContext(BadgeContext);

    return (
        <StyledLabel
            color={labelColor ?? color}
            isBold={isBold}
            labelSize={labelSize}
        >
            {label ?? props.children}
        </StyledLabel>
    );
}

export default Label;
